import { SortOptions } from './model';

export const PAGE_KEY = 'puslapis';
export const PAGE_SIZE_KEY = 'puslapyje';
export const SORT_KEY = 'rikiavimas';
export const SORT_DEFAULT = SortOptions.Newest;
export const DEFAULT_PAGE_SIZE = 12;
export const DEFAULT_PAGE = 1;

export const CARDS_LIST_TEST_IDS = {
    LIST: 'blog-tag-page-cards-list',
    PAGINATION: 'blog-tag-page-cards-list--pagination',
    SORT_SELECTOR: 'blog-tag-page-sort-selector',
};
